import { render, staticRenderFns } from "./GrNavLink.vue?vue&type=template&id=c074b5a6&"
import script from "./GrNavLink.vue?vue&type=script&lang=ts&"
export * from "./GrNavLink.vue?vue&type=script&lang=ts&"
import style0 from "./GrNavLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports